/* ============================================================
   azado Kaufbox-Erweiterungen (Produktseite)
   Markup: <template>s in sections/azado-product.liquid (#az-buybox-<section>).
   - Eignungszeile unter dem Titel
   - "Komplettiere dein Set" (Grills): Zubehör abhaken, alles mit einem Klick in den Warenkorb
   - Gesamtpreis direkt im Kaufbutton
   - Aufklappbare Infos unter dem Button
   - Mitlaufende Kaufleiste, sobald der Kaufbutton aus dem Bild ist
   Die native Dawn-Logik (product-form.js / product-info.js) bleibt unangetastet; nur wenn im
   Set etwas angehakt ist, übernimmt dieses Script das Hinzufügen (alle Artikel in EINEM
   /cart/add.js-Aufruf) und löst danach dasselbe "cart:added"-Event aus wie Dawn.
   ============================================================ */
(function () {
  "use strict";

  function formatMoney(cents, format) {
    var value = (cents / 100);
    function withSep(n, dec, thou, sep) {
      var parts = n.toFixed(dec).split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(sep);
    }
    var out = (format || "CHF {{amount}}").replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case "amount_no_decimals": return withSep(value, 0, ",", ".");
        case "amount_with_comma_separator": return withSep(value, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return withSep(value, 0, ".", ",");
        case "amount_with_apostrophe_separator": return withSep(value, 2, "'", ".");
        case "amount_no_decimals_with_space_separator": return withSep(value, 0, " ", ".");
        case "amount_with_space_separator": return withSep(value, 2, " ", ",");
        default: return withSep(value, 2, ",", ".");
      }
    });
    var tmp = document.createElement("textarea");
    tmp.innerHTML = out; /* money_format kommt HTML-escaped aus Liquid … */
    return tmp.value.replace(/<[^>]*>/g, "").trim(); /* … und kann ein <span class="money"> enthalten */
  }

  function directChildOf(container, el) {
    while (el && el.parentElement && el.parentElement !== container) el = el.parentElement;
    return el && el.parentElement === container ? el : null;
  }

  function init(root) {
    if (!root || root.dataset.bound) return;
    var info = document.querySelector("#MainContent .product__info-container");
    var form = info && info.querySelector("product-form form");
    var submit = form && form.querySelector(".product-form__submit");
    if (!info || !form || !submit) return;
    root.dataset.bound = "true";

    var moneyFormat = root.dataset.moneyFormat;
    var unitPrice = parseInt(root.dataset.price, 10) || 0;
    var buyBlock = directChildOf(info, submit);

    function tpl(name) {
      var t = root.querySelector("template[data-az-" + name + "]");
      return t ? t.content.cloneNode(true) : null;
    }

    /* 1. Eignungszeile + Bewertungen direkt unter dem Titel */
    var fit = tpl("fit");
    var rating = tpl("rating");
    var title = info.querySelector(".product__title");
    if (rating && title) title.parentNode.insertBefore(rating, title.nextSibling);
    if (fit && title) title.parentNode.insertBefore(fit, title.nextSibling);

    /* 1b. HeidiPay/HeyLight-Ratenanzeige direkt unter dem Preis, SDK einmalig laden */
    var heylight = tpl("heylight");
    var priceEl = info.querySelector('[id^="price-"]');
    var hlBox = null;
    if (heylight && priceEl) {
      hlBox = heylight.querySelector(".az-heylight");
      /* Logo-Farbe passend zum gewählten Design (hell/dunkel, siehe initThemeToggle) */
      var hlc = hlBox.querySelector("#heidipay-container");
      if (hlc && document.documentElement.getAttribute("data-theme") === "light") hlc.setAttribute("data-heylight-logo-variant", "black");
      priceEl.parentNode.insertBefore(heylight, priceEl.nextSibling);
      if (!document.querySelector('script[src*="heidi-upstream-lib"]')) {
        var sdk = document.createElement("script");
        sdk.src = "https://upstream.heidipay.com/sdk/heidi-upstream-lib.js";
        sdk.async = true;
        document.head.appendChild(sdk);
      }
    }
    function updateHeylight(cents) {
      if (!hlBox || !cents) return;
      var old = hlBox.querySelector("#heidipay-container");
      if (!old || old.getAttribute("data-heylight-minorAmount") === String(cents)) return;
      /* frischer Container, damit das SDK neu rendert */
      var fresh = old.cloneNode(false);
      fresh.setAttribute("data-heylight-minorAmount", String(cents));
      old.parentNode.replaceChild(fresh, old);
      /* HeyLight-SDK: initCoreHeidiCode() sucht alle #heidipay-container neu und rendert sie */
      if (typeof window.initCoreHeidiCode === "function") { try { window.initCoreHeidiCode(); } catch (e) {} }
    }

    /* 2. Set-Auswahl direkt über dem Kaufbutton */
    var setFrag = tpl("set");
    var setEl = null;
    if (setFrag && buyBlock) {
      setEl = setFrag.querySelector(".az-set");
      info.insertBefore(setFrag, buyBlock);
      /* Gruppen-Tabs (Schutz / Grillieren / Extras) */
      setEl.querySelectorAll(".az-set__tab").forEach(function (tab) {
        tab.addEventListener("click", function () {
          var idx = tab.dataset.tab;
          setEl.querySelectorAll(".az-set__tab").forEach(function (t) { t.setAttribute("aria-selected", t === tab ? "true" : "false"); });
          setEl.querySelectorAll(".az-set__panel").forEach(function (panel) { panel.hidden = panel.dataset.panel !== idx; });
        });
      });
    }

    /* 3. Infos direkt unter dem Kaufbutton (Grills: native "Abholung"-Box ersetzt, sie verspricht
       "fertig in 24 Stunden", was bei Grills mit Spedition/Absprache nicht passt) */
    var infoFrag = tpl("info");
    if (infoFrag && buyBlock) {
      info.insertBefore(infoFrag, buyBlock.nextSibling);
      /* Klasse statt hidden: Dawns pickup-availability.js blendet sich nach dem Laden selbst wieder ein */
      if (root.dataset.grill === "true") info.classList.add("az-buybox--grill");
    }
    /* Vertrauenszeile direkt unter dem Kaufbutton (vor den Infos) */
    var trust = tpl("trust");
    if (trust && buyBlock) info.insertBefore(trust, buyBlock.nextSibling);

    /* 4. Gesamtpreis im Kaufbutton */
    var priceSpan = document.createElement("span");
    priceSpan.className = "az-cta-price";
    submit.appendChild(priceSpan);

    function quantity() {
      var q = document.querySelector('#MainContent input[name="quantity"]');
      return Math.max(1, parseInt(q && q.value, 10) || 1);
    }
    function checkedAddons() {
      return setEl ? Array.prototype.slice.call(setEl.querySelectorAll(".az-set__input:checked")) : [];
    }
    function total() {
      return unitPrice * quantity() + checkedAddons().reduce(function (sum, cb) {
        return sum + (parseInt(cb.dataset.price, 10) || 0);
      }, 0);
    }

    var sticky = null, stickyPrice = null;
    function render() {
      var text = unitPrice ? formatMoney(total(), moneyFormat) : "";
      priceSpan.textContent = text;
      if (stickyPrice) stickyPrice.textContent = text;
      if (setEl) {
        setEl.querySelectorAll(".az-set__item").forEach(function (item) {
          item.classList.toggle("is-checked", item.querySelector("input").checked);
        });
        setEl.querySelectorAll(".az-set__panel").forEach(function (panel) {
          var n = panel.querySelectorAll(".az-set__input:checked").length;
          var count = setEl.querySelector('.az-set__tab[data-tab="' + panel.dataset.panel + '"] .az-set__count');
          if (count) count.textContent = n ? String(n) : "";
        });
      }
    }

    /* Holz des Grills (Kernesche/Nussbaum) aufs Zubehör übertragen, wo es beide Hölzer gibt */
    function applyWood(variantTitle) {
      if (!setEl) return;
      var wantNut = /nussbaum/i.test(variantTitle || "");
      setEl.querySelectorAll(".az-set__input[data-alt-id]").forEach(function (cb) {
        if (!cb.dataset.baseId) {
          cb.dataset.baseId = cb.value; cb.dataset.basePrice = cb.dataset.price; cb.dataset.baseTitle = cb.dataset.title;
        }
        var baseIsNut = /nussbaum/i.test(cb.dataset.baseTitle);
        var useAlt = wantNut !== baseIsNut;
        cb.value = useAlt ? cb.dataset.altId : cb.dataset.baseId;
        cb.dataset.price = useAlt ? cb.dataset.altPrice : cb.dataset.basePrice;
        var item = cb.closest(".az-set__item");
        var t = item.querySelector("[data-az-variant-title]");
        if (t) t.textContent = useAlt ? cb.dataset.altTitle : cb.dataset.baseTitle;
        var pr = item.querySelector("[data-az-addon-price]");
        if (pr) pr.textContent = "+ " + formatMoney(parseInt(cb.dataset.price, 10), moneyFormat);
      });
    }
    applyWood(root.dataset.variantTitle);

    /* Hervorgehobene Zusätze (z. B. Nachfüllgas): Animation erst, wenn die Box sichtbar wird */
    if (setEl && "IntersectionObserver" in window) {
      var recs = setEl.querySelectorAll(".az-set__item.is-recommended");
      if (recs.length) {
        var recIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { en.target.classList.add("is-inview"); recIo.unobserve(en.target); }
          });
        }, { threshold: 0.6 });
        recs.forEach(function (el) { recIo.observe(el); });
      }
    }
    if (setEl) setEl.addEventListener("change", render);
    document.addEventListener("change", function (e) {
      if (e.target && e.target.name === "quantity") render();
    });
    /* Variantenwechsel: Dawn publiziert die neue Variante über pubsub.js */
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        var v = evt && evt.data && evt.data.variant;
        unitPrice = v ? v.price : 0;
        if (v) { applyWood(v.title); updateHeylight(v.price); }
        render();
      });
    }

    /* Set: alles in einem Aufruf hinzufügen. Capture-Phase, damit Dawns eigener Submit-Handler
       gar nicht erst läuft (sonst käme der Grill doppelt in den Warenkorb). */
    document.addEventListener("submit", function (e) {
      if (e.target !== form) return;
      var addons = checkedAddons();
      if (!addons.length) return; /* ohne Set: ganz normaler Dawn-Ablauf */
      e.preventDefault();
      e.stopImmediatePropagation();
      if (submit.getAttribute("aria-disabled") === "true" || submit.disabled) return;

      var data = new FormData(form);
      var items = [{ id: parseInt(data.get("id"), 10), quantity: quantity() }].concat(addons.map(function (cb) {
        return { id: parseInt(cb.value, 10), quantity: 1 };
      }));
      submit.setAttribute("aria-disabled", "true");
      submit.classList.add("loading");
      var spinner = submit.querySelector(".loading__spinner");
      if (spinner) spinner.classList.remove("hidden");
      var err = setEl.querySelector(".az-set__error");
      if (err) err.remove();

      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : "/cart/add") + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message || "");
          addons.forEach(function (cb) { cb.checked = false; });
          render();
          document.dispatchEvent(new CustomEvent("cart:added", { detail: res }));
        })
        .catch(function (error) {
          if (window.azadoInstantFail) window.azadoInstantFail((error && error.message) || "");
          var p = document.createElement("p");
          p.className = "az-set__error";
          p.textContent = (error && error.message) || setEl.dataset.error || "";
          setEl.appendChild(p);
        })
        .finally(function () {
          submit.removeAttribute("aria-disabled");
          submit.classList.remove("loading");
          if (spinner) spinner.classList.add("hidden");
        });
    }, true);

    /* 5. Mitlaufende Kaufleiste */
    var stickyFrag = tpl("sticky");
    if (stickyFrag && "IntersectionObserver" in window) {
      sticky = stickyFrag.querySelector(".az-stickybuy");
      stickyPrice = sticky.querySelector("[data-az-sticky-price]");
      document.body.appendChild(stickyFrag);
      var stickyBtn = sticky.querySelector(".az-stickybuy__btn");
      stickyBtn.addEventListener("click", function () {
        if (submit.disabled) { submit.scrollIntoView({ behavior: "smooth", block: "center" }); return; }
        submit.click();
      });

      var buttonOut = false, footerIn = false;
      function syncSticky() {
        var show = buttonOut && !footerIn && !submit.disabled;
        sticky.classList.toggle("is-visible", show);
        sticky.setAttribute("aria-hidden", show ? "false" : "true");
        stickyBtn.tabIndex = show ? 0 : -1;
        document.body.classList.toggle("az-sticky-on", show);
      }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          /* zeigen, sobald der Kaufbutton nicht im Bild ist — auch wenn er auf kleinen Bildschirmen
             noch unterhalb liegt, damit "In den Warenkorb" immer einen Klick entfernt ist */
          buttonOut = !en.isIntersecting;
        });
        syncSticky();
      }).observe(submit);
      var footer = document.querySelector("footer.footer");
      if (footer) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { footerIn = en.isIntersecting; });
          syncSticky();
        }).observe(footer);
      }
    }

    render();
  }

  function boot() {
    document.querySelectorAll('[id^="az-buybox-"]').forEach(init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
